import { Button, ButtonGroup, Divider, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useToast } from "@chakra-ui/react";
import { Form } from "components";
import { useState } from "react";

export default function ModalPassword({ onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ password, setPassword ] = useState()
    const [ loading, setLoading ] = useState(false)

    const onSubmit = async () => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
            toast({ title: 'Autenticação realizada com sucesso', status: 'success' })
            onSuccess()
            props.onClose()
        }, 2000)
    }

    return(
    <Modal closeOnOverlayClick={!loading} {...props}>
        <ModalOverlay />
        <ModalContent>
            <ModalHeader children="🔑 Autenticação necessária" />
            <ModalBody>
                Para realizar a ação solicitada, precisamos que insira novamente a sua senha de acesso.
                <Divider my={4} />
                <Form.Form onSubmit={onSubmit}>
                    <Form.Password 
                        required
                        label="Insira a sua senha:"
                        placeholder="•••••••"
                        size="lg"
                        isDisabled={loading}
                    />
                    <Button colorScheme="orange" isLoading={loading} type="submit" size="lg" children="Continuar" />
                </Form.Form>
            </ModalBody>
            <ModalFooter>

            </ModalFooter>
        </ModalContent>
    </Modal>
    )
}